import {Component, OnInit, Input, ElementRef, HostListener, EventEmitter, Output} from '@angular/core';

@Component({
  selector: 'luci-menu',
  templateUrl: './luci-menu.component.html',
  styleUrls: ['./luci-menu.component.scss']
})
export class LuciMenuComponent implements OnInit {

  @Input() isNested = false;
  @Input() menu = [];
  @Input() menuText: '';
  @Input() icon = '';
  @Input() isOpen = false;
  @Input() isIconListMenu = false;
  @Input() menuButtonCls = '';
  @Input() menuContainerCls = '';
  @Input() isIconMenu = false;
  @Input() buttonMenu = true;
  @Input() innerIcon = '';
  @Input() isMenuSelect = false;
  @Input() classList = '';

  @Output() updateSelectedItem  = new EventEmitter();

  selectedItem: any = {};
  selectedChildItem: any = {};
  hoverItem: any = {};

  @HostListener('document:click', ['$event'])
  clickout(event) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.isOpen = false;
      this.hoverItem = {};
    }
  }
  constructor(private eRef: ElementRef) {
  }
  ngOnInit() {
  }

  selectListItem(event, item) {
    this.selectedItem = item;
    this.hoverItem = {};
    this.isOpen = false;
    if (!this.selectedItem.children || (this.selectedItem.children && this.selectedItem.children.length === 0)) {
      this.updateSelectedItem.emit(this.selectedItem);
    }
    event.stopPropagation();
    event.preventDefault();
  }

  getIcon() {
    return `assets/icons/luci.svg#${this.icon}`;
  }

  selectChildListItem(item) {
    this.selectedChildItem = item;
    this.updateSelectedItem.emit(item);
    this.isOpen = false;
    this.hoverItem = {};
  }

  showChild(event, item) {
    this.hoverItem = item;
    setTimeout ( () => {
      if (this.eRef.nativeElement.querySelector('#menu-child')) {
        this.eRef.nativeElement.querySelector('#menu-child').style.top  =  event.target.offsetTop + 'px';
        this.eRef.nativeElement.querySelector('#menu-child').style.right  = event.target.offsetWidth + 'px';
      }
    });

    event.stopPropagation();
    event.preventDefault();
  }

}
